module.exports = __webpack_public_path__ + "img/smartStore02.105b7cae.png";